import { OrderItem } from "./order-item.model";

	/**
	 * @description
	 *  Modelo de un ítem en una nota de CyR o NC, sobre un pedido, para
	 *	creación.
	 *
	 * @see gigot-backend/ViewModels/OrderEvent/OrderEventItemForCreationDto.cs
	 */

export class OrderEventItemForCreation {

	public orderEventId: number;
	public orderItemId: number;
	public quantity: number;

	/**
	 * @description
	 *	Construye un ítem de una nota con una semántica vacía. Nótese que no
	 *	es lo mismo que construir un ítem con valores por defecto. Las reglas
	 *	generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un ítem en una nota de CyR/NC vacío.
	 */
	public static empty(): OrderEventItemForCreation {
		const orderEventItemForCreation: OrderEventItemForCreation = new OrderEventItemForCreation();
		orderEventItemForCreation.orderEventId = undefined;
		orderEventItemForCreation.orderItemId = undefined;
		orderEventItemForCreation.quantity = undefined;
		return orderEventItemForCreation;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicOrderEventItemForCreation
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicOrderEventItemForCreation: OrderEventItemForCreation): OrderEventItemForCreation {
		if (!anemicOrderEventItemForCreation) return undefined;
		const orderEventItemForCreation: OrderEventItemForCreation = OrderEventItemForCreation.empty();
		orderEventItemForCreation.orderEventId = anemicOrderEventItemForCreation.orderEventId;
		orderEventItemForCreation.orderItemId = anemicOrderEventItemForCreation.orderItemId;
		orderEventItemForCreation.quantity = anemicOrderEventItemForCreation.quantity;
		return orderEventItemForCreation;
	}

	/**
	 * @description
	 *	.
	 *
	 * @param orderItem
	 *	.
	 *
	 * @returns
	 *	.
	 */
	public static fromOrderItem(orderItem: OrderItem): OrderEventItemForCreation {
		if (!orderItem) return undefined;
		const orderEventItemForCreation: OrderEventItemForCreation = OrderEventItemForCreation.empty();
		orderEventItemForCreation.orderEventId = undefined;
		orderEventItemForCreation.orderItemId = orderItem.id;
		orderEventItemForCreation.quantity = orderItem.quantity;
		return orderEventItemForCreation;
	}
}
